import {SET_FETCH_CACHE, SET_FETCH_CACHE_ITEM} from '@/store/mutation-types';
import {CLEAR_FETCH_CACHE, CACHE_FETCHED, FETCH_ENTITY, GREEDY_FETCH_ENTITY} from '@/store/action-types';

let mutation_types = {SET_FETCH_CACHE, SET_FETCH_CACHE_ITEM};
let action_types = {CLEAR_FETCH_CACHE, CACHE_FETCHED, FETCH_ENTITY, GREEDY_FETCH_ENTITY};

const state = {
    fetch_cache: parseFetchCache(),
}

const getters = {
    getFetchCache: state => state.fetch_cache,
    getFetchCacheItem: state => (entity, params) => {
        return getFetchCacheItem(state, entity, params)
    },
    isFetched: state => (entity, params) => {
        return !!getFetchCacheItem(state, entity, params)
    }
};

function parseFetchCache() {
    return localStorage.getItem('fetch_cache') ? (JSON.parse(localStorage.getItem('fetch_cache') || {}) || {}) : {};
}

function createCheckSum(entity, params) {
    return entity + '_' + btoa(JSON.stringify((params || {})));
}

function setFetchCacheItem(state, entity, params, data) {
    state.fetch_cache[createCheckSum(entity, (params || {}))] = data;
    localStorage.setItem('fetch_cache', JSON.stringify(state.fetch_cache));
}

function getFetchCacheItem(state, entity, params) {
    return state.fetch_cache[createCheckSum(entity, (params || {}))];
}

const mutations = {
    SET_FETCH_CACHE: function(state, cache){
        state.fetch_cache = cache;
        localStorage.setItem('fetch_cache', state.fetch_cache);
    },
    SET_FETCH_CACHE_ITEM: function(state, {entity, params, data}){
        setFetchCacheItem(state, entity, params, data);
    }
}

const actions = {
    CLEAR_FETCH_CACHE: ({commit}) => {
        commit(SET_FETCH_CACHE, []);
    },
    CACHE_FETCHED: ({commit}, {entity, params, data}) => {
        params = (params || {});
        commit(SET_FETCH_CACHE_ITEM, {entity, params, data});
    },
    FETCH_ENTITY: ({dispatch, getters}, {model, params, refresh}) => {
        console.log({model, params, refresh});
        refresh = refresh === true ? true : false;
        params = (params || {});
        if(!refresh && getters.isFetched(model.entity, params) && model.query().count()) {
            return new Promise(resolve => {
                let data = getters.getFetchCacheItem(model.entity, params) || {};
                let entities = {};
                entities[model.entity] = model.query().whereIdIn(data.keys || []).get();
                return resolve({cached: true, entities, pagination: data.pagination || {}});
            });
        }
        return model.api().fetch(params).then((response) => {
            if(!response.entities[model.entity]) {
                response.entities[model.entity] = [];
            }
            let keys = response.entities[model.entity].map(model => model.id);
            let pagination = response.response.data.data.pagination;
            dispatch(CACHE_FETCHED, {entity: model.entity, params, data: {keys, pagination}});
            response.pagination = pagination;
            return response;
        });
    },
    GREEDY_FETCH_ENTITY: ({dispatch}, {model, params, refresh}) => {
        params = (params || {});
        params.limit = 99999;
        refresh = refresh === true ? true : false;
        return dispatch(FETCH_ENTITY, {model, params, refresh});
    },
};

export default {
    getters,
    mutations,
    actions,
    state
}
  